"use strict";

module.exports.toJSON = require('./js/usfmToJson').usfmToJSON;
module.exports.toUSFM = require('./js/jsonToUsfm').jsonToUSFM;
module.exports.removeMarker = require('./js/filter').removeMarker;